module.exports = __webpack_public_path__ + "static/media/ic_add_lot.c7347074.svg";